<app-slide-dialog-layout (dismissed)="dismiss()">
    <div left [translate]="'CLOSE'" i18n="@@CLOSE">Close</div>
    <div title [translate]="'THEME'" i18n="@@THEME">Theme</div>

    <div class="flex justify-center gap-4">
        <button type="button" class="basis-1/3 space-y-2" (click)="changeTheme('light')">
            <img class="rounded-lg" [src]="images()?.light" alt="" />
            <dc-radio-button [checked]="selectedTheme() === 'light'">
                <div dcTypography="geist-14-medium" [translate]="'LIGHT'" i18n="@@LIGHT">Light</div>
            </dc-radio-button>
        </button>

        <button type="button" class="basis-1/3 space-y-2" (click)="changeTheme('dark')">
            <img class="rounded-lg" [src]="images()?.dark" alt="" />
            <dc-radio-button [checked]="selectedTheme() === 'dark'">
                <div dcTypography="geist-14-medium" [translate]="'DARK'" i18n="@@DARK">Dark</div>
            </dc-radio-button>
        </button>

        <button type="button" class="basis-1/3 space-y-2" (click)="changeTheme('system')">
            <img class="rounded-lg" [src]="images()?.system" alt="" />
            <dc-radio-button [checked]="selectedTheme() === 'system'">
                <div dcTypography="geist-14-medium" [translate]="'SYSTEM'" i18n="@@SYSTEM">System</div>
            </dc-radio-button>
        </button>
    </div>

    <app-toggle-switch class="mt-6 w-full" [model]="accessibilityMode()" (itemChange)="toggleAccessibilityMode()">
        <div [translate]="'ACCESSIBILITY_MODE'" i18n="@@ACCESSIBILITY_MODE">Accessibility mode</div>
    </app-toggle-switch>
</app-slide-dialog-layout>
